import React, { Component, } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import * as authServices from '../services/authService'
import * as authUtil from "../util/auth.util";
class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            passcode: "",
            oldpasscode: "",
            repasscode: "",
            date: "",
            passVisible: false,
            oldpassVisible: false,
            repassVisible: false,
            showToast: false,
            toastMsg: "",
            toastType: ""
        };
    }
    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            authUtil.logout(true);
        }
        this.setState({ uid: userData.sub })
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    handleKey(e) {
        if (e.keyCode === 13) {
            if (this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode) {
                this.submitForm();
            } else {
                this.props.notify("Invalid", "error")
            }
        }
    }
    async submitForm() {
        if (!this.state.oldpasscode) {
            this.props.notify("Please insert old password!", "error")
            return false
        }

        if (!this.state.passcode) {
            this.props.notify("Please insert new password!", "error")
            return false
        }

        if (this.state.passcode.length < 6) {
            this.props.notify("Password must have atlist 6 digit!", "error")
            return false
        }

        if (this.state.passcode !== "" && this.state.passcode !== this.state.repasscode) {
            return false
        }
        let body = {
            "OldPassword": this.state.oldpasscode,
            "NewPassword": this.state.passcode,
            "ConfirmPassword": this.state.repasscode
        }
        await authServices.changePassword(body).then((res) => {
            if (res.isSuccess) {
                this.setState({ oldpasscode: "", passcode: "", repasscode: "" })
                this.props.notify("Password changed successfully!", "success")
                this.props.history.push('/home')
            } else {
                this.props.notify(res.exception.message, "error")
            }
        })
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            if (name === "passcode" && !!value) {
                if (value.match(/[0-9]/g)) {
                    document.getElementById("digit").className = "success-text"
                } else {
                    document.getElementById("digit").className = ""
                }

                if (value.match(/[a-zA-Z]/g)) {
                    document.getElementById("scharacter").className = "success-text"
                } else {
                    document.getElementById("scharacter").className = ""
                }

                if (value.length >= 8) {
                    document.getElementById("minlength").className = "success-text"
                } else {
                    document.getElementById("minlength").className = ""
                }

                if (value === this.state.oldpasscode) {
                    document.getElementById("notold").className = "error-text d-block"
                } else {
                    document.getElementById("notold").className = "error-text d-none"
                }

                if (value.toLowerCase().indexOf(this.state.uid.toLowerCase()) !== -1) {
                    document.getElementById("notuser").className = "error-text d-block"
                } else {
                    document.getElementById("notuser").className = "error-text d-none"
                }
            }
        })
    }

    onPasswodVisible(passid, name, value) {
        if (!!value) {
            document.getElementById(passid).type = "Password"
        } else {
            document.getElementById(passid).type = "text"
        }
        this.setState({ [name]: !value })
    }

    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Change Password</p>
                            </div>
                            <div className="allreport col3 ">
                                <div className="row mx-0 pt-3">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                        <div className="row mx-0">
                                            <div className="col-12 ">
                                                <div className="form-group">
                                                    <label htmlFor="text">Old Password:</label>
                                                    <input type="Password" value={this.state.oldpasscode} name="oldpasscode" id="oldpasscode" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                    <span onClick={() => { this.onPasswodVisible("oldpasscode", "oldpassVisible", this.state.oldpassVisible) }} className="changePasscode-visible">{!!this.state.oldpassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                                </div>
                                            </div>
                                            <div className="col-12 ">
                                                <div className="form-group change-password-valid">
                                                    <label htmlFor="text">New Password:</label>
                                                    <input type="Password" value={this.state.passcode} name="passcode" id="passcode" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                    <span onClick={() => { this.onPasswodVisible("passcode", "passVisible", this.state.passVisible) }} className="changePasscode-visible">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                                    {!!this.state.passcode && <>
                                                        <ul>
                                                            <li id="digit" className=""><i className="fa fa-check"></i> At least 1 digit</li>
                                                            <li id="scharacter" className=""><i className="fa fa-check"></i> At least 1 character</li>
                                                            <li id="minlength" className=""><i className="fa fa-check"></i> Minimum 8 characters</li>
                                                        </ul>
                                                        <ul>
                                                            <li id="notold" className="error-text d-none"><i className="fa fa-close"></i> Password not same as old</li>
                                                            <li id="notuser" className="error-text d-none"><i className="fa fa-close"></i> Password Not contain Username</li>
                                                        </ul>
                                                    </>}
                                                </div>
                                            </div>
                                            <div className="col-12 ">
                                                <div className="form-group">
                                                    <label htmlFor="text">Confirm Password:</label>
                                                    <input name="repasscode" id="repasscode" type="Password" onKeyUp={(e) => { this.handleKey(e) }} value={this.state.repasscode} onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                    <span onClick={() => { this.onPasswodVisible("repasscode", "repassVisible", this.state.repassVisible) }} className="changePasscode-visible">{!!this.state.repassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                                    {this.state.passcode !== "" && this.state.passcode !== this.state.repasscode && <span className="text-danger">This field should be same as password.</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mx-0">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3 change-pass"><button onClick={(e) => { this.submitForm() }} className="btn place-bet-btn" disabled={this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode ? false : true}>Update</button></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);